
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.926 4.03c-1.885 1.95-1.474 5.187.686 6.622a.181.181 0 00.227-.022c.454-.445.839-.875 1.176-1.422a.17.17 0 00-.067-.24 2.196 2.196 0 01-.842-.866 2.113 2.113 0 01-.18-1.443c.136-.652.836-1.259 1.37-1.82l-.003-.001 2.005-2.046a2.056 2.056 0 012.919-.015 2.08 2.08 0 01.03 2.934L12.033 6.96a.213.213 0 00-.048.218c.28.81.348 1.953.16 2.817-.005.024.025.04.043.022L14.77 7.38c1.65-1.684 1.637-4.427-.03-6.094a4.335 4.335 0 00-6.157.031L5.936 4.019l-.01.01z"}}),_c('path',{attrs:{"d":"M10.756 11.023l.005-.002c.527-.964.63-2.07.384-3.148l-.002.001a4.349 4.349 0 00-1.754-2.5.24.24 0 00-.265.012c-.443.358-.877.817-1.163 1.403a.194.194 0 00.077.254c.332.193.632.475.833.85.157.264.31.766.211 1.306-.093.715-.816 1.371-1.39 1.963L5.7 13.196a2.081 2.081 0 01-2.934.03 2.08 2.08 0 01-.03-2.934L3.952 9.04a.213.213 0 00.05-.214c-.27-.83-.345-1.947-.174-2.81.005-.023-.025-.039-.042-.021L1.241 8.592c-1.667 1.702-1.653 4.473.032 6.157a4.344 4.344 0 006.125-.062c.58-.648 3.059-2.944 3.358-3.664z"}})])
          )
        }
      }
    